module.exports = __webpack_public_path__ + "img/play-audio-icon.fec60358.svg";